export default "__VITE_ASSET__Z6Q2FL5s__"